import { showError } from './utils';
import axios from 'axios';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '',
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    // 如果有响应体且包含message，优先使用响应体中的message
    if (error.response?.data?.message) {
      const customError = new Error(error.response.data.message);
      customError.name = 'AxiosError';
      customError.response = error.response;
      showError(customError);
      return Promise.reject(customError);
    }
    showError(error);
    return Promise.reject(error);
  }
);
